module.exports = __webpack_public_path__ + "img/ico_wl2.b659be0a.png";